import {
  ContentStates,
  type ContentStateEnum,
} from '../../enums/ContentStateEnum'

interface ContentStateInput {
  submittedQuery: string
  hasRecentItems: boolean
  isSearchLoading: boolean
}

export function deriveContentState(
  input: ContentStateInput
): Nullable<ContentStateEnum> {
  if (input.submittedQuery === '' && input.hasRecentItems) {
    return ContentStates.RECENTS
  }
  if (input.isSearchLoading) {
    return ContentStates.LOADING
  }
  return null
}
